import React , {useState , useEffect} from 'react';
import { fetchTotalDraftCars } from '../../stores/api_calls/dashboard';
import {FaTags} from 'react-icons/fa'
import {AiOutlineArrowRight} from 'react-icons/ai'
import './card.scss'
import { useNavigate } from 'react-router-dom';

const DraftCars = () => {

    const navigate = useNavigate()
    const [soldCars , setSoldCars] = useState()
    const [isLoading , setIsLoading] = useState(false)

    useEffect(()=>{
        setIsLoading(true)
        const getSoldCars = fetchTotalDraftCars()

        getSoldCars.then((res)=>{
            if(res.data){
                if(res.data.success){
                    setSoldCars(res.data.data)
                    setIsLoading(false)
                }
            }
        }).catch((e)=>{
            console.log(e)
        })
    },[])

    return (
        <div>
            <div className='draft header-card'>
                <p className='header-text'>Draft <br/> Cars</p>
                <FaTags/>
            </div>
            <div className='draft body-card'>
                <p className='draft-text'>Total : {isLoading ? 'fetching' : !isLoading&&soldCars? soldCars.total_draft_products : 0}</p>
                <div className='goIcon' onClick={()=>navigate("../cars/draft", { replace: true })}>
                    <AiOutlineArrowRight/>
                </div>
            </div>
        </div>
    )
}

export default DraftCars;
